import { render, staticRenderFns } from "./header.vue?vue&type=template&id=8b941730&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=8b941730&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=8b941730&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b941730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b941730')) {
      api.createRecord('8b941730', component.options)
    } else {
      api.reload('8b941730', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=8b941730&scoped=true", function () {
      api.rerender('8b941730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/header.vue"
export default component.exports